module.exports = __webpack_public_path__ + "img/47.b0ba44a9.jpg";